// Game Constants
export const GAME_TIMER_SECONDS = 30;
export const PREGAME_COUNTDOWN_SECONDS = 4;
export const BOARD_SIZE = 9; // 3x3 grid

// Validation Constants
export const PASSWORD_MIN_LENGTH = 7;

// Computer AI Constants (box counts for decision making)
export const EMPTY_BOARD = 9;
export const FIRST_MOVE = 9;
export const SECOND_MOVE = 7;
export const THIRD_MOVE = 5;
export const FIRST_MOVE_O = 8;
export const SECOND_MOVE_O = 6;
